import { render, staticRenderFns } from "./pageWrapper.vue?vue&type=template&id=366b1d9a&"
import script from "./pageWrapper.vue?vue&type=script&lang=js&"
export * from "./pageWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports